import styled from '@emotion/styled';
import { SubTitle, useTheme } from '@teko/ds-mobile';
import React from 'react';

interface ITabItemProps {
  isActive: boolean;
  onClick: () => void;
  title: string;
}

export const TabItem = ({ isActive, onClick, title }: ITabItemProps) => {
  const { colors } = useTheme();
  return (
    <StyledWrapper
      style={{
        borderColor: isActive ? colors.primary : colors.border,
        backgroundColor: isActive ? colors.primary100 : 'white',
      }}
      onClick={onClick}
    >
      <SubTitle>{title}</SubTitle>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  padding: 8px;
  border-style: solid;
  border-width: 1px;
  border-radius: 999px;
  margin-right: 8px;
  cursor: pointer;
`;
